var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-angle-small-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0224 12.3319C10.9787 12.2883 10.9441 12.2366 10.9205 12.1797C10.8968 12.1227 10.8847 12.0617 10.8847 12C10.8847 11.9383 10.8968 11.8773 10.9205 11.8203C10.9441 11.7634 10.9787 11.7117 11.0224 11.6681L15.3217 7.36968C15.5856 7.106 15.7338 6.74832 15.7339 6.37533C15.734 6.00234 15.5859 5.64459 15.3222 5.38078C15.0585 5.11697 14.7009 4.96872 14.3279 4.96863C13.9549 4.96854 13.5971 5.11663 13.3333 5.38031L9.03394 9.67968C8.41966 10.2957 8.07471 11.1301 8.07471 12C8.07471 12.8699 8.41966 13.7043 9.03394 14.3203L13.3333 18.6197C13.5971 18.8834 13.9549 19.0315 14.3279 19.0314C14.7009 19.0313 15.0585 18.883 15.3222 18.6192C15.5859 18.3554 15.734 17.9977 15.7339 17.6247C15.7338 17.2517 15.5856 16.894 15.3217 16.6303L11.0224 12.3319Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.3968acddf0cd0a653d2d18e6ac28869b.svg";
export { ForwardRef as ReactComponent };